const galleryData = [
  { id: 1, src: '/images/gallery/img1.jpg', caption: 'Community Service' },
  { id: 2, src: '/images/gallery/img2.jpg', caption: 'Education Program' },
  { id: 3, src: '/images/gallery/img3.jpg', caption: 'Health Camp' },
  { id: 4, src: '/images/gallery/img4.jpg', caption: 'Skill Training' },
  { id: 5, src: '/images/gallery/img5.jpg', caption: 'Social Harmony' },
  { id: 6, src: '/images/gallery/img6.jpg', caption: 'Community Events' },
  { id: 7, src: '/images/gallery/img7.jpg', caption: 'Welfare Activities' },
  { id: 8, src: '/images/gallery/img8.jpg', caption: 'Volunteer Work' },
]
export default galleryData
